<template>
  <div
    class="wrapper-item bac-white"
    @click="clickItem"
  >
    <p v-if="item.userName" class="user-name clearfix">{{ item.userName }}</p>
    <div class="custom-item clearfix">
      <div class="avatar-wrapper">
        <img
          :src="
            item.sex === '男'
              ? portraitMale
              : item.sex === '女'
                ? portraitFemale
                : portrait
          "
          class="avatar"
        />
      </div>
      <div
        :class="[
          'custom-item-right',
          {
            'has-feedback-score': hasExpertFeedbackScore,
            'has-two-feedback-scores': hasBothExpertFeedbackScores,
          },
        ]"
      >
        <div class="header clearfix card-header-row">
          <div class="name card-name">
            <span class="name-w">{{ item.physician_name }}</span>
            <span v-if="item.expert_level" class="tag-nrdl">
              {{ item.expert_level }}
            </span>
            <span v-if="item.is_nrdl" class="tag-nrdl">重点客户</span>
            <span v-if="showKdm" class="tag-kdm">KDM</span>
            <!-- <span v-if="item.ex_data_support" class="tag-yellow">外</span> -->
            <span v-if="item.is_sync" class="tag-yellow t-update">更</span>
            <span v-if="item.is_wechat">
              <img class="weixin" src="@/assets/svg/weixin.svg" alt="" />
            </span>
            <span v-if="item.territory_id_agent" class="tag-yellow t-white">
              代管{{ item.territory_id_agent }}
            </span>
          </div>
          <div v-if="products.length" class="parting-label">
            <div
              v-for="(productItem, productIndex) in products"
              :key="productIndex"
            >
              <div v-if="productItem.sales_segment" class="product-badge">
                <div class="product-badge-top">
                  <div class="segment-circle">
                    {{ productItem.sales_segment }}
                  </div>
                  <div v-if="productItem.segment" class="segment-text">
                    {{ productItem.segment }}
                  </div>
                </div>
                <div class="product-name">
                  {{ productItem.product_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasExpertFeedbackScore" class="feedback-score-row">
          <span
            v-if="hasFeedbackScore(item.expert_familiarity_score)"
            class="feedback-score-chip familiarity"
          >{{ $t('ga_admin_customer_familiarity_score', {
            score: formatFeedbackScore(item.expert_familiarity_score),
          }) }}</span>
          <span
            v-if="hasFeedbackScore(item.expert_alignment_score)"
            class="feedback-score-chip alignment"
          >{{ $t('ga_admin_customer_alignment_score', {
            score: formatFeedbackScore(item.expert_alignment_score),
          }) }}</span>
        </div>
        <div>
          <p class="department">
            {{ item.department_name }} {{ item.professional_title }}
          </p>
        </div>

        <div class="address">
          <div class="hospital">
            <span>{{ item.institution_name }}</span>
          </div>
        </div>
        <div v-if="item.ex_data_support === false" class="no-external-data">
          <font-awesome-icon :icon="['fas', 'ban']" class="no-data-icon" />
          <span>无外部数据</span>
        </div>
      </div>
      <div v-if="!isKol && item.is_favorite" class="fav-hcp">
        <Icon name="star" />
      </div>
      <div v-if="isKol && item.is_favorite" class="fav-kol-absolute">
        <Icon name="star" />
      </div>
      <div v-if="showVisitButton" class="action-buttons-container">
        <!-- <div class="portrait-btn" @click.stop="clickItem(item)">
          <span class="btn-text">画像</span>
        </div> -->
        <div class="visit-btn" @click.stop="enterVisit(item)">
          <!-- <Icon name="manager" size="14" color="#fff" class="btn-icon" /> -->
          <span class="btn-text">拜访</span>
          <!-- <Icon name="arrow" size="12" color="#fff" /> -->
        </div>
      </div>
      <!-- hcp -->
    </div>

    <slot></slot>
  </div>
</template>
<script>
import beforeFavoriteMixins from '@/mixins/beforeFavoriteMixins';
import {getLocalStorage, hasKdmPermission, isKdmTrue} from '@/utils/index';
import {Button, Icon} from 'vant';
export default {
  components: {
    // Button,
    Icon,
  },
  mixins: [beforeFavoriteMixins],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    parting: {
      type: String,
      default() {
        return '';
      },
    },
    physicianSegment: {
      type: String,
      default() {
        return '';
      },
    },
    hideVisitButton: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      portrait: require('@/assets/lundbeck/avatar-unknown.png'),
      portraitMale: require('@/assets/lundbeck/avatar-male.png'),
      portraitFemale: require('@/assets/lundbeck/avatar-female.png'),
    };
  },
  computed: {
    isKol() {
      if (
        this.$route.name === 'KolHome' ||
        this.$route.name === 'doctorListHome'
      ) {
        return true;
      } else {
        return false;
      }
    },
    isGbaRole() {
      const roleName = getLocalStorage('role_name');
      return roleName === 'GBA' || roleName === 'GA';
    },
    showKdm() {
      return hasKdmPermission() && isKdmTrue(this.item.is_kdm);
    },
    showVisitButton() {
      return !this.hideVisitButton && (this.isKol || this.isGbaRole);
    },
    hasExpertFeedbackScore() {
      return this.hasFeedbackScore(this.item.expert_familiarity_score) ||
        this.hasFeedbackScore(this.item.expert_alignment_score);
    },
    hasBothExpertFeedbackScores() {
      return this.hasFeedbackScore(this.item.expert_familiarity_score) &&
        this.hasFeedbackScore(this.item.expert_alignment_score);
    },
    products() {
      let products = this.item.products ? JSON.parse(this.item.products) : [];

      // Merge Brintellix and Lexapro
      const bIndex = products.findIndex(p => p.product_name === 'Brintellix');
      const lIndex = products.findIndex(p => p.product_name === 'Lexapro');

      if (bIndex > -1 && lIndex > -1) {
        const bItem = products[bIndex];
        const lItem = products[lIndex];
        if (bItem.sales_segment === lItem.sales_segment && bItem.segment === lItem.segment) {
          const newItem = {
            ...bItem,
            product_name: 'B/L'
          };
          products = products.filter((p, index) => index !== bIndex && index !== lIndex);
          products.push(newItem);
        }
      }

      return products.sort((a, b) => {
        const segmentA = a.product_name ? a.product_name.toLowerCase() : '';
        const segmentB = b.product_name ? b.product_name.toLowerCase() : '';
        if (segmentA < segmentB) {
          return -1;
        }
        if (segmentA > segmentB) {
          return 1;
        }
        return 0;
      });
    },
  },

  methods: {
    hasFeedbackScore(value) {
      return value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value));
    },
    formatFeedbackScore(value) {
      const score = Number(value);
      return Number.isInteger(score) ? String(score) : score.toFixed(1);
    },
    clickItem(item) {
      this.$emit('clickItem', item);
    },
    enterVisit(item) {
      if (this.$route.name === 'gbaDoctorList' || this.isGbaRole) {
        this.$router.push({
          path: `/gba/visit-create?physician_id=${item.physician_id}`,
        });
      } else {
        this.$router.push({
          path: `/kol/visit-create?physician_id=${item.physician_id}`,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/var.scss';
.box {
  border-top: none;
}
.custom-item {
  display: flex;
  align-items: center;
  position: relative;
  // background-color: #ffffff;
  padding: 10px 10px 6px 10px;
  // margin-bottom: 10px;
  .avatar-wrapper {
    width: 45px;
    height: 45px;
    margin: 0 5px;
    border-radius: 50%;
    background: linear-gradient(165deg, #dce1f0, #f6eff1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .avatar {
    width: 50px;
    height: 50px;
    object-fit: cover;
    opacity: 0.5;
  }
  .custom-item-right {
    position: relative;
    flex: 1;
    min-width: 0;
    font-size: 12px;
    text-align: left;
    padding-left: 10px;
    @include suggest-detail-header();
    .count {
      // float: right;
      font-size: 19px;
      color: #b2b2b2;
      .count-color {
        color: #ab351c;
        min-width: 32px;
      }
    }
    .department {
      padding: 6px 0 4px 0;
      color: #888;
    }
    .address {
      color: #b2b2b2;
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      .hospital {
        flex: 1;
        min-width: 0;
        width: 0;
        line-height: 20px;
        span {
          display: block;
        }
      }
      .cube-btn {
        // width: 84px;
        padding: 4px 8px;
        font-size: 11px;
        border-radius: 20px;
      }
    }
    .no-external-data {
      display: inline-flex;
      align-items: center;
      background-color: #f0f0f0;
      color: #666666;
      padding: 3px 8px 2px;
      border-radius: 10px;
      font-size: 10px;
      margin-top: 4px;
      .no-data-icon {
        margin-right: 4px;
        font-size: 9px;
      }
    }
  }
}
.wrapper-item {
  border-radius: 12px;
  padding: 6px 0;
  margin-top: 0px;
  margin-bottom: 8px;
  &.top {
    border: 1px solid #80d3ae;
    background: #f1f7f5;
  }
  .score-more {
    display: block;
    font-size: 10px;
    transition: transform 0.3s;
    &.selected {
      transform: rotate(180deg);
    }
    .more-icon {
      color: #d9d9d9;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
.title {
  font-size: 14px;
  color: #000;
  text-align: left;
  padding: 10px;
}
::v-deep .cube-popup-content {
  width: 94%;
}
@import '@/styles/card-item-popup.scss';
.badge-icon {
  display: block;
  font-size: 10px;
  line-height: 16px;
}
.btn-follow {
  float: right;
  padding: 2px 13px;
  background-color: #aa341b;
  border-radius: 10px;
  color: #fff;
}
.cube-follow-btn {
  width: initial !important;
  padding: 4px 8px !important;
  font-size: 12px;
  border-radius: 20px;
  & + .cube-follow-btn {
    margin-left: 10px;
  }
  .dimension-icon {
    margin-right: 2px;
  }
}
.Badge-tui {
  ::v-deep {
    .van-badge {
      padding: 2px 8px;
      top: -12px;
      right: -42px;
      -webkit-transform-origin-x: 0;
      transform: scale(0.8);
      // right: initial;
    }
  }
}
.name-suffix {
  display: inline-block;
  margin-left: 4px;
}
.user-name {
  font-size: 15px;
  text-align: left;
  padding: 5px 15px;
}
.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  min-width: 0;
}
.feedback-score-row {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}
.has-feedback-score {
  .card-header-row,
  .department {
    padding-right: 86px;
  }
}
.has-two-feedback-scores {
  .address {
    padding-right: 86px;
  }
}
.feedback-score-chip {
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 10px;
  line-height: 15px;
  white-space: nowrap;
  &.familiarity {
    color: #a64028;
    background: #fff1ec;
  }
  &.alignment {
    color: #456d9f;
    background: #eef4fb;
  }
}
.card-name {
  flex: 1 1 0;
  min-width: 0;
  padding-right: 8px;
}
.parting-label {
  display: flex;
  flex: 0 1 auto;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 4px;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin-top: -10px;
  margin-bottom: 2px;
  overflow: hidden;
  > div {
    max-width: 100%;
    min-width: 0;
    flex: 0 1 auto;
  }
  .parting-label-child {
    padding: 4px 3px;
    // background: #9d997c;
    background: #dcdacb;
    border-radius: 5px 5px 5px 5px;
    font-size: 12px;
    font-family: Arial;
    font-weight: 400;
    // color: #ffffff;
    color: #2c2b26;
    max-width: 4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // & + .parting-label-child {
    //   margin-left: 5px;
    // }
    margin-left: 2px;
  }
}
.tag-yellow {
  padding: 3px 2px 2px 2px;
  color: #ffffff;
  // font-weight: bold;
  // -webkit-transform: skewX(-12deg);
  // transform: skewX(-12deg);
  border-radius: 2px;
  display: inline-block;
  font-size: 10px;
  background-color: #c7bbba;
  margin-left: 5px;
  height: 10px;
  &.t-update {
    background-color: #89d329;
  }
  &.t-white {
    color: #000;
    background-color: #ffffff;
  }
}
.tag-nrdl {
  padding: 4px 6px 2px;
  color: #aa341b;
  border: 1px solid #aa341b;
  border-radius: 8px;
  display: inline-block;
  font-size: 9px;
  margin: 0 0 0 4px;
  background-color: #fff0ed;
}
.tag-kdm {
  padding: 4px 6px 2px;
  color: #aa341b;
  border: 1px solid #aa341b;
  border-radius: 8px;
  display: inline-block;
  font-size: 9px;
  margin: 0 0 0 4px;
  background-color: #fff0ed;
}
.p-relative {
  // display: flex;
  // position: relative;
  // width: 60px;
  // text-align: left;
  .p-hidden {
    // visibility: hidden;
    // scale: 0.7;
    display: none;
  }
  .p-abs {
    display: block;
    // vertical-align: sub;
    font-size: 7px;
    // scale: 0.6;
    // position: absolute;
    // bottom: -3px;
    // left: 3px;
  }
}
.weixin {
  width: 16px;
  height: 16px;
  margin-left: 5px;
}
.name-d {
  margin-left: 5px;
}
.fav-hcp {
  position: absolute;
  right: 10px;
  top: 38px;
  z-index: 1;
  font-size: 24px;
  color: #aa341b;
}
.fav-kol-absolute {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 22px;
  color: #aa341b;
}
.action-buttons-container {
  align-self: center;
  display: flex;
  align-items: center;
  margin-left: 5px;
}
.portrait-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid #aa341b;
  color: #aa341b;
  margin-right: 8px;
  cursor: pointer;
  background: #fff;
  box-sizing: border-box;

  .btn-text {
    font-size: 13px;
    line-height: 1;
  }
}
.visit-btn {
  display: flex;
  align-items: center;
  background: linear-gradient(165deg, #d2563d, #aa341b);
  padding: 6px 12px;
  border-radius: 20px;
  color: white;
  box-shadow: 0 2px 8px rgba(170, 52, 27, 0.05);
  margin-right: 5px;
  cursor: pointer;

  .btn-icon {
    margin-right: 4px;
  }

  .btn-text {
    font-size: 13px;
    margin-right: 2px;
    line-height: 1;
  }
}
.product-badge {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  box-sizing: border-box;
  background: linear-gradient(180deg, #fcfcfc 0%, #f3efe6 100%);
  border: 1px solid #dccdb6;
  border-radius: 8px;
  padding: 4px 5px 2px;
  text-align: center;

  .product-badge-top {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 1px;
  }

  .segment-circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #8b7d6b;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  }

  .segment-text {
    margin-left: 2px;
    max-width: 76px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 9px;
    color: #4a4a4a;
    font-weight: bold;
    white-space: nowrap;
  }
  .product-name {
    font-size: 8px;
    color: #4a4a4a;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
